/**
 * Cor de cada letra do extrato, como no design: círculo e segmento da barra, e o fundo claro
 * do chip de percentual. Letras além do D (não ocorrem hoje) repetem a paleta.
 */
const PALETA = [
  { forte: 'bg-brand-yellow', clara: 'bg-brand-yellow-light' },
  { forte: 'bg-brand-green', clara: 'bg-[#DFFFF8]' },
  { forte: 'bg-brand-purple-light', clara: 'bg-[#EEECFF]' },
  { forte: 'bg-brand-pink-light', clara: 'bg-[#FFE9F3]' },
];

export function coresDaLetra(letra: string) {
  const indice = Math.max(0, letra.charCodeAt(0) - 'A'.charCodeAt(0));
  return PALETA[indice % PALETA.length];
}
